import { Injectable } from '@angular/core';
import { RepositoryService, UnitOfWorkService } from '@mri/breeze-entity';
import { MetadataStore } from 'breeze-client';
import { Report } from '../models';
import { reportQueries } from './queries';

@Injectable({ providedIn: 'root' })
export class ReportRepositoryService extends RepositoryService<Report> {
  constructor(uow: UnitOfWorkService, metadataStore: MetadataStore) {
    super(uow, metadataStore, reportQueries.selectAll);
  }
}
